import React from 'react';

import { SvgProps } from '../enums';

export const FlagTC: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_55145"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_55145)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V12H16V0H0Z"
        fill="#2E42A5"
      />
      <mask
        id="mask1_270_55145"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_270_55145)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M10.5233 5.01636C10.5233 5.01636 10.9663 10.982 12.9643 10.982C14.9623 10.982 15.4537 5.01636 15.4537 5.01636H10.5233Z"
          fill="#FECA00"
          stroke="#F7FCFF"
          strokeWidth="0.25"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M12.9556 5.31091L13.0288 5.22828L13.3757 5.44931C13.426 5.37118 13.5155 5.33483 13.6408 5.34083L13.5142 5.14811L13.6173 5.09321L13.8575 5.38238L13.8812 5.38983L13.8204 5.01407L13.9411 5L14.02 5.48693C14.0219 5.48683 14.0238 5.48678 14.0257 5.48678C14.0597 5.48678 14.098 5.50319 14.1374 5.52924L14.2232 5L14.3439 5.01407L14.283 5.38983L14.3068 5.38238L14.547 5.09321L14.6501 5.14811L14.5235 5.34083C14.6488 5.33483 14.7383 5.37118 14.7886 5.44931L15.1355 5.22828L15.2087 5.31091L14.8281 5.55343C14.8332 5.58084 14.8359 5.61088 14.8359 5.64355V5.69979L15.3612 5.58464L15.4 5.68236L14.8359 5.88224V5.95048L15.3707 5.90717L15.3868 6.00955L14.8359 6.08972V6.20763L15.3882 6.29887L15.3659 6.40049L14.8359 6.32125V7.47032H14.7546V6.3091L14.399 6.25595C14.3592 6.53711 14.3143 6.89109 14.3206 7.01907C14.3268 7.14552 14.4212 7.19971 14.4875 7.23775C14.539 7.26734 14.5736 7.28716 14.5363 7.32362C14.4512 7.40695 14.2385 7.48678 14.0257 7.48678C13.813 7.48678 13.6031 7.40695 13.5576 7.32362C13.5495 7.30875 13.5506 7.30995 13.5578 7.31831C13.5914 7.35681 13.7574 7.54718 13.7704 7.01907C13.7775 6.72929 13.735 6.4677 13.6861 6.26778L13.4097 6.3091V7.47032H13.3284V6.32125L12.7984 6.40049L12.7761 6.29887L13.3284 6.20763V6.08972L12.7775 6.00955L12.7936 5.90717L13.3284 5.95048V5.88224L12.7643 5.68236L12.803 5.58464L13.3284 5.69979V5.64355C13.3284 5.61088 13.331 5.58084 13.3362 5.55343L12.9556 5.31091ZM13.6509 6.13665C13.6525 6.1422 13.6542 6.14783 13.6558 6.15354L13.4097 6.1942V6.10155L13.6509 6.13665ZM13.656 5.75716C13.6523 5.76124 13.6487 5.76526 13.6451 5.76921L13.4097 5.7176V5.64355C13.4097 5.62877 13.4102 5.61469 13.4114 5.60131L13.656 5.75716ZM13.8125 5.60241C13.7852 5.62593 13.7582 5.6513 13.7327 5.67673L13.4419 5.4915C13.4828 5.4206 13.5632 5.39482 13.6884 5.41337L13.8125 5.60241ZM14.3472 5.73049L14.7223 5.4915C14.6815 5.4206 14.6011 5.39482 14.4759 5.41337L14.3019 5.67839C14.3177 5.69594 14.3329 5.7135 14.3472 5.73049ZM14.4737 5.77917L14.7529 5.60131C14.754 5.61469 14.7546 5.62877 14.7546 5.64355V5.7176L14.4737 5.77917ZM14.5862 5.9707L14.7546 5.91103V5.95706L14.5862 5.9707ZM14.4564 6.14494L14.7546 6.10155V6.1942L14.4564 6.14494ZM13.4097 5.91103V5.95706L13.5781 5.9707L13.4097 5.91103Z"
          fill="#CF6900"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M12.439 7.92139C12.439 7.92139 11.7821 9.02144 11.7821 9.68822C11.7821 9.68822 12.2297 10.0432 12.9995 10.0432C13.7694 10.0432 14.1655 9.68822 14.1655 9.68822C13.9487 8.89781 13.5798 7.92139 13.5798 7.92139H12.439Z"
          fill="#00A727"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M12.4709 7.61755C12.4709 7.31461 12.7165 7.06903 13.0195 7.06903C13.3224 7.06903 13.568 7.31461 13.568 7.61755V7.99279H12.4709V7.61755Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M10.7595 6.41673C10.7595 6.41673 11.6265 6.59534 11.6265 6.87696C11.6265 7.15858 11.9755 7.26013 12.0613 7.18399C12.1471 7.10786 12.7512 7.0546 12.7512 6.68752C12.7512 6.32044 12.8016 6.2205 12.6549 5.9874C12.5081 5.75429 12.2021 4.96632 12.1317 5.28203C12.0613 5.59773 11.9553 5.8316 11.7595 5.64342C11.5637 5.45523 11.3123 5.05682 11.224 5.28203C11.1357 5.50723 11.5037 5.73329 11.224 5.73329C10.9443 5.73329 11.1414 5.74805 11.1414 5.93874C11.1414 6.12942 11.1746 6.30916 10.9671 6.30916C10.7595 6.30916 10.7595 6.41673 10.7595 6.41673Z"
          fill="#FF927F"
        />
        <mask
          id="mask2_270_55145"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="9"
          height="7"
        >
          <rect width="9" height="7" fill="white" />
        </mask>
        <g mask="url(#mask2_270_55145)">
          <path
            // eslint-disable-next-line max-len
            d="M-1.00208 6.49987L0.9784 7.36847L9.045 0.94433L10.0897 -0.346436L7.97182 -0.636747L4.68165 2.1316L2.0334 3.99682L-1.00208 6.49987Z"
            fill="#F7FCFF"
          />
          <path
            d="M-0.730957 7.10849L0.278004 7.61255L9.71451 -0.466309H8.29782L-0.730957 7.10849Z"
            fill="#F50100"
          />
          <path
            // eslint-disable-next-line max-len
            d="M10.0022 6.49987L8.02172 7.36847L-0.0448761 0.94433L-1.08953 -0.346436L1.0283 -0.636747L4.31847 2.1316L6.96673 3.99682L10.0022 6.49987Z"
            fill="#F7FCFF"
          />
          <path
            // eslint-disable-next-line max-len
            d="M9.93457 6.93667L8.92561 7.44073L4.90745 3.98176L3.71615 3.59529L-1.1901 -0.341973H0.226597L5.13009 3.50184L6.43256 3.96525L9.93457 6.93667Z"
            fill="#F50100"
          />
          <mask
            id="path-14-outside-1_270_55145"
            maskUnits="userSpaceOnUse"
            x="-1"
            y="-1"
            width="11"
            height="9"
            fill="black"
          >
            <rect fill="white" x="-1" y="-1" width="11" height="9" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.99226 0H3.99226V3H0V4H3.99226V7H4.99226V4H9V3H4.99226V0Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.99226 0H3.99226V3H0V4H3.99226V7H4.99226V4H9V3H4.99226V0Z"
            fill="#F50100"
          />
          <path
            // eslint-disable-next-line max-len
            d="M3.99226 0V-0.75H3.24226V0H3.99226ZM4.99226 0H5.74226V-0.75H4.99226V0ZM3.99226 3V3.75H4.74226V3H3.99226ZM0 3V2.25H-0.75V3H0ZM0 4H-0.75V4.75H0V4ZM3.99226 4H4.74226V3.25H3.99226V4ZM3.99226 7H3.24226V7.75H3.99226V7ZM4.99226 7V7.75H5.74226V7H4.99226ZM4.99226 4V3.25H4.24226V4H4.99226ZM9 4V4.75H9.75V4H9ZM9 3H9.75V2.25H9V3ZM4.99226 3H4.24226V3.75H4.99226V3ZM3.99226 0.75H4.99226V-0.75H3.99226V0.75ZM4.74226 3V0H3.24226V3H4.74226ZM0 3.75H3.99226V2.25H0V3.75ZM0.75 4V3H-0.75V4H0.75ZM3.99226 3.25H0V4.75H3.99226V3.25ZM4.74226 7V4H3.24226V7H4.74226ZM4.99226 6.25H3.99226V7.75H4.99226V6.25ZM4.24226 4V7H5.74226V4H4.24226ZM9 3.25H4.99226V4.75H9V3.25ZM8.25 3V4H9.75V3H8.25ZM4.99226 3.75H9V2.25H4.99226V3.75ZM4.24226 0V3H5.74226V0H4.24226Z"
            fill="#F7FCFF"
            mask="url(#path-14-outside-1_270_55145)"
          />
        </g>
      </g>
    </g>
  </svg>
);
